import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "q-mr-xs text-cool-gray-70 k-action-button__title-hover"
}

import { ref } from 'vue'

interface IProps {
  label: string
  title?: string
  size?: 'sm' | 'md' | 'lg'
  leftIcon?: string
  rightIcon?: string
  disable?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KActionBtn' },
  __name: 'KActionBtn',
  props: {
    label: {},
    title: { default: '' },
    size: { default: 'lg' },
    leftIcon: { default: '' },
    rightIcon: { default: '' },
    disable: { type: Boolean, default: false }
  },
  setup(__props: any) {





const isHovered = ref(false)

return (_ctx: any,_cache: any) => {
  const _component_KIcon = _resolveComponent("KIcon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    "no-caps": "",
    unelevated: "",
    class: _normalizeClass(["k-action-button rounded-12 q-pa-sm fw-500", [
      __props.disable && 'k-action-button--disable',
      {
        'fs-17px': __props.size === 'lg',
        'fs-15px': __props.size === 'md',
        'fs-13px': __props.size === 'sm',
      },
    ]]),
    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (isHovered.value = false)),
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (isHovered.value = true))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        (__props.leftIcon)
          ? (_openBlock(), _createBlock(_component_KIcon, {
              key: 0,
              class: "q-mr-sm",
              size: __props.size === 'sm' ? '20px' : '24px',
              color: !__props.disable ? (!isHovered.value ? 'cool-gray-70' : 'space-b-100') : 'cool-gray-60',
              name: __props.leftIcon
            }, null, 8, ["size", "color", "name"]))
          : _createCommentVNode("", true),
        (__props.title)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.title) + ": ", 1))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: _normalizeClass({ 'text-cool-gray-100': __props.title })
        }, _toDisplayString(__props.label), 3),
        (__props.rightIcon)
          ? (_openBlock(), _createBlock(_component_KIcon, {
              key: 2,
              class: "q-ml-sm",
              size: __props.size === 'sm' ? '20px' : '24px',
              name: __props.rightIcon,
              color: !__props.disable ? (!isHovered.value ? 'cool-gray-70' : 'space-b-100') : 'cool-gray-60'
            }, null, 8, ["size", "name", "color"]))
          : _createCommentVNode("", true)
      ]),
      _renderSlot(_ctx.$slots, "action")
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})